export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FilesView.vue?vue&type=template&id=0b0215f0"


//////////////////
// WEBPACK FOOTER
// ./src/pages/extranet/FilesView.vue?vue&type=template&id=0b0215f0
// module id = 2103
// module chunks = 31